export const educationLevelQuestion = {
  answers: [
    {
      answer: 'None',
      icon: 'none',
      value: 'none',
    },
    {
      answer: 'High School / GED',
      icon: 'highschool',
      value: 'highschool',
    },
    {
      answer: 'Associate',
      hint: '(AA,AS, etc.)',
      icon: 'associate',
      value: 'associate',
    },
    {
      answer: "Bachelor's",
      hint: '(BS/BA, etc.)',
      icon: 'bachelor',
      value: 'bachelor',
    },
    {
      answer: "Master's",
      icon: 'advanced',
      value: 'advanced',
    },
    {
      answer: 'Doctorate',
      hint: '(Including MD/JD/etc.)',
      icon: 'professional',
      value: 'professional',
    },
  ],
  qName: 'education-level-select',
};

export const educationDegreeOptions = [
  { text: 'None', value: 'None' },
  { text: 'High School / GED', value: 'High School Diploma' },
  { text: 'Associate', value: 'Associate' },
  { text: "Bachelor's", value: "Bachelor's" },
  { text: "Master's", value: "Master's" },
  { text: 'Doctorate', value: 'Doctorate' },
];
